// import axiosInstance from "../axios";
import { setAxiosAuthorizationHeader } from "../axios/index.js";

export const setAuthorization = function ({ token }) {
  // axiosInstance.defaults.headers.common["Authorization"] = `Basic ${token}`;
  // window.localStorage.setItem('user',JSON.stringify(user))
  window.localStorage.setItem('token', token)
  setAxiosAuthorizationHeader(token)
}

export function getAuthorizationToken () {
  return window.localStorage.getItem('token')
}

export function handleLogin (response) {
  const { data } = response.data
  setAuthorization(data)
}

export function handleLogOut () {
  localStorage.removeItem("token")
  localStorage.removeItem("user")
}